import { Stack, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import * as React from 'react';
import { Navigate, Route, Routes } from 'react-router';
import PageLayout from 'v2/layout/PageLayout/PageLayout';
import NotFound from 'v2/pages/GeneralErrors/NotFound';
import Past from 'v2/pages/Visits/Past/Past';
import Upcoming from 'v2/pages/Visits/Upcoming/Upcoming';
import Cancelled from './Cancelled/Cancelled';

const Visits: React.FC<React.PropsWithChildren> = () => {
  const { translation } = useTranslation();

  return (
    <PageLayout>
      <Stack spacing={1}>
        <Typography variant="h4">{translation.visitors}</Typography>
        <Typography variant="body1" color="text.secondary">
          {translation.visitors_page_subtitle}
        </Typography>
      </Stack>
      <Routes>
        <Route path="/upcoming" element={<Upcoming />} />
        <Route path="/past" element={<Past />} />
        <Route path="/cancelled" element={<Cancelled />} />
        <Route path="/" element={<Navigate to="upcoming" replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </PageLayout>
  );
};

export default Visits;
